import PropTypes from 'prop-types';
import React from 'react';
import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

function AreaGraphic({
  data,
  lines,
  rangeVertical,
  height,
  width,
  colorsCharts,
  minTickGap,
  tickCount,
  tickXY,
  tickXX,
  tickYX,
  tickYY,
  typeLine,
  showXAxis,
  showYAxis,
  marginRight,
  lineStrokeWidth,
  formatterAxisX,
  formatterAxisY,
  formatterTooltip,
}) {
  function renderLines() {
    return lines.map((item, i) => {
      return (
        <Area
          key={i}
          type={typeLine}
          dataKey={item.text}
          stroke={colorsCharts[i]}
          activeDot={{ r: 8 }}
          strokeWidth={lineStrokeWidth}
          dot={null}
          fill={`url(#linearGradient${i})`}
        />
      );
    });
  }

  const renderQuarterTickX = (tickProps) => {
    const { x, y, payload } = tickProps;
    const { value } = payload;
    const split = value ? value.split('-*-') : [''];
    const text = formatterAxisX ? formatterAxisX(split[0]) : split[0];

    return (
      <>
        <text x={x + tickXX} y={y + tickXY} className="linear-graphic__tick-x-title">
          {' '}
          {text}
        </text>
        {split.length > 1 && (
          <text x={x} y={y + 32} className="linear-graphic__tick-x-text">
            {split[1]}
          </text>
        )}
      </>
    );
  };

  const renderQuarterTickY = (tickProps) => {
    const { x, y, payload } = tickProps;
    const { value } = payload;
    const text = formatterAxisY ? formatterAxisY(value) : value;

    return (
      <>
        <text x={x + tickYX} y={y + tickYY} className="linear-graphic__tick-y-title">
          {text}
        </text>
      </>
    );
  };

  return (
    <div className="linear-graphic">
      <ResponsiveContainer width={width} height={height}>
        <AreaChart
          data={data}
          margin={{
            top: 5,
            right: marginRight,
            left: 0,
            bottom: 5,
          }}
        >
          <defs>
            {data.map((item, index) => {
              return (
                <linearGradient id={`linearGradient${index}`} x1="0" y1="0" x2="0" y2="1" key={index}>
                  <stop offset="5%" stopColor={colorsCharts[index]} stopOpacity={0.3} />
                  <stop offset="95%" stopColor={colorsCharts[index]} stopOpacity={0} />
                </linearGradient>
              );
            })}
          </defs>
          <CartesianGrid strokeDasharray="4 2" />
          {showXAxis && <XAxis dataKey="name" tick={renderQuarterTickX} />}
          {showYAxis && <YAxis domain={rangeVertical} tick={renderQuarterTickY} tickCount={tickCount} minTickGap={minTickGap} />}
          {data.length !== 0 && renderLines()}
          <Tooltip formatter={formatterTooltip} />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}

AreaGraphic.propTypes = {
  data: PropTypes.array,
  lines: PropTypes.array,
  rangeVertical: PropTypes.array,
  colorsCharts: PropTypes.array,
  showXAxis: PropTypes.bool,
  showYAxis: PropTypes.bool,
  marginRight: PropTypes.number,
  lineStrokeWidth: PropTypes.number,
  formatterAxisX: PropTypes.func,
  formatterAxisY: PropTypes.func,
  formatterTooltip: PropTypes.func,
};

AreaGraphic.defaultProps = {
  rangeVertical: [0, 10],
  width: '100%',
  height: '100%',
  data: [],
  lines: [],
  tickCount: 5,
  minTickGap: 5,
  colorsCharts: [],
  tickXX: 0,
  tickXY: 18,
  tickYX: -22,
  tickYY: 4,
  typeLine: 'monotone',
  showXAxis: true,
  showYAxis: true,
  marginRight: 30,
  lineStrokeWidth: 3,
};

// ejemplo de data:
// el name es lo que se muestra en la barra horizontal
// [{ name: 'January' , teachers: 200, students: 100 }, { name: 'February',  teachers: 300, students: 200 }]

export default AreaGraphic;
